export const BETA_STORAGE_KEY = 'beta';
export const BETA_SITE_URL = 'https://new.indiefy.net';

export function hasBetaPreference() {
  return localStorage.getItem(BETA_STORAGE_KEY) !== null;
}

export function clearBetaPreference() {
  localStorage.removeItem(BETA_STORAGE_KEY);
}

export function setBetaPreference() {
  localStorage.setItem(BETA_STORAGE_KEY, '1');
}

export function isNoBetaQuery(value) {
  const values = Array.isArray(value) ? value : [value];
  return values.some((entry) => String(entry) === '1');
}

/**
 * `?nobeta=1` on any URL clears the stored choice and keeps the
 * current site. Any other visit with `beta` set should leave for
 * the new site.
 */
export function shouldRedirectToBetaSite(search = '') {
  const query = search.startsWith('?') ? search.slice(1) : search;
  const nobeta = new URLSearchParams(query).get('nobeta');

  if (isNoBetaQuery(nobeta)) {
    clearBetaPreference();
    return false;
  }

  return hasBetaPreference();
}

/**
 * Same path and query on the new site. A visit to
 * /forms/680d26422b32772a121d950c?lang=es stays on that form.
 */
export function betaSiteDestination(location = window.location) {
  const path = location.pathname || '/';
  const search = location.search || '';
  const hash = location.hash || '';

  return `${BETA_SITE_URL}${path}${search}${hash}`;
}

export function goToBetaSite() {
  setBetaPreference();
  window.location.replace(betaSiteDestination());
}
